var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h3", {
                      staticClass: "title mt-4",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("apeironGwApp.programa.datosGenerales")
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("apeironGwApp.programa.clave") + " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "clave", type: "text", disabled: "" },
                            model: {
                              value: _vm.programa.clave,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "clave", $$v)
                              },
                              expression: "programa.clave",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "9" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.nombre") + " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "nombre",
                              type: "text",
                              disabled: _vm.readOnly,
                            },
                            on: {
                              input: function ($event) {
                                _vm.programa.nombre =
                                  _vm.programa.nombre.toUpperCase()
                              },
                            },
                            model: {
                              value: _vm.programa.nombre,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "nombre", $$v)
                              },
                              expression: "programa.nombre",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.nombre?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.programa.nombreDeLaMaximaInstancia"
                              ) + " *",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                disabled: _vm.readOnly,
                                placeholder: _vm.$t(
                                  "apeironGwApp.programa.nombreDeLaMaximaInstancia"
                                ),
                              },
                              model: {
                                value: _vm.programa.maximaInstancia,
                                callback: function ($$v) {
                                  _vm.$set(_vm.programa, "maximaInstancia", $$v)
                                },
                                expression: "programa.maximaInstancia",
                              },
                            },
                            _vm._l(
                              _vm.instanciasColegiadas,
                              function (item, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: item } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.instancia) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.maximaInstancia?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.numeroDeActa") +
                              " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "numeroDeActa",
                              disabled: _vm.readOnly,
                            },
                            model: {
                              value: _vm.programa.numeroDeActa,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "numeroDeActa", $$v)
                              },
                              expression: "programa.numeroDeActa",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.numeroDeActa?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.programa.numeroDeActa?.minLength
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("entity.validation.minlength", {
                                  min: 2,
                                })
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.programa.numeroDeActa?.maxLength
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("entity.validation.maxlength", {
                                  max: 100,
                                })
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.programa.fechaDeAprobacion"
                              ) + " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "fechaAprobacion",
                              disabled: _vm.readOnly,
                              type: "date",
                            },
                            model: {
                              value: _vm.programa.fechaAprobacion,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "fechaAprobacion", $$v)
                              },
                              expression: "programa.fechaAprobacion",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.fechaAprobacion?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("apeironGwApp.programa.rvoe"),
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "rvoe", disabled: _vm.readOnly },
                            model: {
                              value: _vm.programa.rvoe,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "rvoe", $$v)
                              },
                              expression: "programa.rvoe",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.anteDgp") + " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "anteDgp", disabled: _vm.readOnly },
                            model: {
                              value: _vm.programa.anteDgp,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "anteDgp", $$v)
                              },
                              expression: "programa.anteDgp",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.anteDgp?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.programa.anteDgp?.minLength
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("entity.validation.minlength", {
                                  min: 2,
                                })
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "12" } }, [
            _c("hr", { staticClass: "separator" }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h3", {
                      staticClass: "title mt-4",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(
                            "apeironGwApp.programa.caracteristicasAcademicas"
                          )
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                        _c("strong", [
                          _c("span", [_vm._v("Campo característica:")]),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "El campo de caracterísitica deja de ser editable cuando se registra la institución; en la sección instituciones."
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.modalidad") + " *",
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-form-select",
                                {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: _vm.$t(
                                      "apeironGwApp.programa.modalidad"
                                    ),
                                  },
                                  model: {
                                    value: _vm.programa.modalidad,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.programa, "modalidad", $$v)
                                    },
                                    expression: "programa.modalidad",
                                  },
                                },
                                _vm._l(_vm.modalidades, function (item, index) {
                                  return _c(
                                    "option",
                                    { key: index, domProps: { value: item } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.modalidad) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.$v.programa.modalidad?.required
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("entity.validation.required"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.caracteristica") +
                              " *",
                          },
                        },
                        [
                          _vm.deshabilitarCampoCaracteristica
                            ? _c("b-form-select", {
                                attrs: {
                                  disabled: _vm.readOnly,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.programa.caracteristica"
                                  ),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "first",
                                      fn: function () {
                                        return [
                                          _c(
                                            "b-form-select-option",
                                            {
                                              attrs: {
                                                value:
                                                  _vm.programa.caracteristica,
                                                disabled: "",
                                              },
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.programa.caracteristica
                                                      ?.caracteristica
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3742271650
                                ),
                                model: {
                                  value: _vm.programa.caracteristica,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.programa,
                                      "caracteristica",
                                      $$v
                                    )
                                  },
                                  expression: "programa.caracteristica",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.deshabilitarCampoCaracteristica
                            ? _c(
                                "b-form-select",
                                {
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    placeholder: _vm.$t(
                                      "apeironGwApp.programa.caracteristica"
                                    ),
                                  },
                                  model: {
                                    value: _vm.programa.caracteristica,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.programa,
                                        "caracteristica",
                                        $$v
                                      )
                                    },
                                    expression: "programa.caracteristica",
                                  },
                                },
                                _vm._l(
                                  _vm.caracteristicas,
                                  function (item, index) {
                                    return _c(
                                      "option",
                                      { key: index, domProps: { value: item } },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.caracteristica) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.programa.caracteristica?.required
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("entity.validation.required"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.orientacion") +
                              " *",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                disabled: _vm.readOnly,
                                placeholder: _vm.$t(
                                  "apeironGwApp.programa.orientacion"
                                ),
                              },
                              model: {
                                value: _vm.programa.orientacion,
                                callback: function ($$v) {
                                  _vm.$set(_vm.programa, "orientacion", $$v)
                                },
                                expression: "programa.orientacion",
                              },
                            },
                            _vm._l(_vm.orientaciones, function (item, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: item } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.orientacion) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          !_vm.$v.programa.orientacion?.required
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("entity.validation.required"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("apeironGwApp.programa.grado") + " *",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                disabled: _vm.readOnly,
                                placeholder: _vm.$t(
                                  "apeironGwApp.programa.grado"
                                ),
                              },
                              model: {
                                value: _vm.programa.grado,
                                callback: function ($$v) {
                                  _vm.$set(_vm.programa, "grado", $$v)
                                },
                                expression: "programa.grado",
                              },
                            },
                            _vm._l(_vm.grados, function (item, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: item } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.grado) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.grado?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("apeironGwApp.programa.tipo") + " *",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                disabled: _vm.readOnly,
                                placeholder: _vm.$t(
                                  "apeironGwApp.programa.tipo"
                                ),
                              },
                              model: {
                                value: _vm.programa.tipo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.programa, "tipo", $$v)
                                },
                                expression: "programa.tipo",
                              },
                            },
                            _vm._l(_vm.tipos, function (item, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: item } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.tipo) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.tipo?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.fechaCreacion") +
                              " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "fechaCreacion",
                              disabled: _vm.readOnly,
                              type: "date",
                            },
                            model: {
                              value: _vm.programa.fechaCreacion,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "fechaCreacion", $$v)
                              },
                              expression: "programa.fechaCreacion",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.fechaCreacion?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.programa.fechaInicio") +
                              " *",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "fechaInicio",
                              disabled: _vm.readOnly,
                              type: "date",
                            },
                            model: {
                              value: _vm.programa.fechaInicio,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "fechaInicio", $$v)
                              },
                              expression: "programa.fechaInicio",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.fechaInicio?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.programa.fechaInicio?.isAfterCreationDate
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "apeironGwApp.snpRegistro.posteriorCreacion"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("apeironGwApp.programa.paginaWeb"),
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { disabled: _vm.readOnly, id: "paginaWeb" },
                            model: {
                              value: _vm.programa.paginaWeb,
                              callback: function ($$v) {
                                _vm.$set(_vm.programa, "paginaWeb", $$v)
                              },
                              expression: "programa.paginaWeb",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$v.programa.paginaWeb?.required
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.required"))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.programa.paginaWeb?.urlPattern
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("entity.validation.urlFormat"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          !_vm.readOnly
            ? _c(
                "b-col",
                { staticClass: "text-right" },
                [
                  !_vm.readOnly
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.clear()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.action.clean")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("b-icon", { attrs: { icon: "eraser" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readOnly
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.$v.$invalid,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.$t("entity.action.save")),
                            },
                          }),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: { icon: "save" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }